<template>
  <li class="row-content" :class="containerClass">
    <span v-if="!isText" class="row-content--side" :class="{'t-xs': isWithCount}">
      <flag
        v-if="!hideFlags && !isTextWithCountry && organisations.length === 1 && organisations[0].country"
        :title="renderCountryFlagTooltip(organisations[0].country)"
        :iso="organisations[0].country.alpha_2 | lowercase" :squared="false" class="flag bd-radius" />

      <i v-else :class="organisations.length > 0 && renderOrganisationCategoryIcon(organisations[0].organisation_types) || 'fa fa-building'" />
      <span v-if="isWithCount && organisations.length > 1">{{ organisations.length }}</span>
    </span>
    <span v-if="!isTextWithCountry" class="row-content--main" v-line-clamp="lineClamp">
      <span v-if="isText" class="t-500">{{ text }}: </span>
      <div v-for="(organisation, index) in organisations" :key="index" class="d-inline">
        <span v-html="getOrganisationName(organisation)" :class="textClass"></span><span v-if="index < organisations.length -1">, </span>
      </div>
    </span>
    <span v-else v-line-clamp="lineClamp" class="row-content--main">
      <span v-if="isText" class="t-500">{{ text }}: </span>
      <span v-for="(organisation, index) in organisations" :key="index">
        <span v-html="$options.filters.titleize(getOrganisationName(organisation))"></span>
        <flag :title="renderCountryFlagTooltip(organisation.country)" v-if="!hideFlags && organisation.country && organisation.country.alpha_2" :iso="organisation.country.alpha_2 | lowercase" :squared="false" class="bd-radius ml-2 mr-2 flag-positioning" />
      </span>
    </span>
  </li>
</template>

<script>
export default {
  name: 'searchPartialOrganisations',
  props: {
    organisations: {
      type: Array,
      required: true
    },
    highlights: {
      type: Object,
      required: false
    },
    highlightKey: {
      type: String,
      required: false,
      default: 'organisations.name'
    },
    highlightKeys: {
      type: Array,
      required: false,
      default: () => ([])
    },
    containerClass: {
      type: String,
      default: ''
    },
    textClass: {
      type: String,
      default: ''
    },
    isWithCount: {
      type: Boolean,
      default: true
    },
    lineClamp: {
      type: Number,
      default: -1
    },
    isText: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Organisation'
    },
    isTextWithCountry: {
      type: Boolean,
      default: false
    },
    hideFlags: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getOrganisationName (organisation) {
      let nameKey = 'name'
      if (organisation.full_name) nameKey = 'full_name'
      let org = organisation[nameKey]

      if (!this.isEmpty(this.highlights) && !this.isEmpty(this.highlightKeys)) {
        for (let highlightKey of this.highlightKeys) {
          for (let o of this.highlights[highlightKey]) if (organisation[nameKey] === this.stripTags(o)) org = o
          return org
        }
      } else if (this.highlights && this.highlights[this.highlightKey]) {
        for (let o of this.highlights[this.highlightKey]) if (organisation[nameKey] === this.stripTags(o)) org = o
        return org
      }

      return organisation[nameKey]
    }
  }
}
</script>
